const phaseColorBar = ["#149AD7", "#283C7E", "#00FFD3", "#91C251", "#FF0000"];

export {phaseColorBar}